let apiBaseUrl = `${process.env.REACT_APP_API_URL}/api`;

const urls = {
    APPLICATION_CODE: "SALES",
    LOGIN_URL: apiBaseUrl + '/v1/Identity/login',
    COMPANY_LIST_URL: apiBaseUrl + '/v1/Company',
    DISTRIBUTER_LIST_URL: apiBaseUrl + '/v1/Distributor',
    COUNTRY_LIST_URL: apiBaseUrl + '/v1/DropDowns/country',
    DESIGNATION_LIST_URL: apiBaseUrl + '/v1/DropDowns/designation',
    DISTRIBUTOR_TYPE_URL: apiBaseUrl + '/v1/Distributor/distributortype',
    CURRENCY_LIST_URL: apiBaseUrl + '/v1/DropDowns/currency',
    DOCUMENT_LIST_URL: apiBaseUrl + '/v1/DropDowns/documentlist',
    DEPARTMENT_LIST_URL: apiBaseUrl + '/v1/DropDowns/department',
    MENU_LIST_URL: apiBaseUrl + '/v1/Role/menu',
    USER_ROLE_URL: apiBaseUrl + '/v1/Role',
    DELIVERY_TERMS_URL: apiBaseUrl + '/v1/DeliveryTerm',
    DELIVERY_MODES_URL: apiBaseUrl + '/v1/DeliveryTerm/deliverymodes',
    PAYMENT_TERMS_URL: apiBaseUrl + '/v1/PaymentTerm',
    INQUIRY_LIST_URL: apiBaseUrl + '/v1/Inquiry',

    //General master
    GENERAL_COUNTRY_LIST_URL: apiBaseUrl + '/v1/GeneralMaster/countries',
    GENERAL_DESIGNATION_LIST_URL: apiBaseUrl + '/v1/GeneralMaster/designations',
    GENERAL_CURRENCY_LIST_URL: apiBaseUrl + '/v1/GeneralMaster/currencies',
    GENERAL_DOCUMENT_LIST_URL: apiBaseUrl + '/v1/GeneralMaster/document-types',
    GENERAL_DEPARTMENT_LIST_URL: apiBaseUrl + '/v1/GeneralMaster/departments',

    // Factory Order
  FACTORY_ORDER_LIST_URL: apiBaseUrl + '/v1/FactoryReleases',
  FACTORY_ORDER_CREATE_URL: apiBaseUrl + '/v1/FactoryReleases/customer-orders',
  FACTORY_CUSTOMER_ORDER_PENDING_URL: apiBaseUrl + '/v1/FactoryReleases/customer-orders/pending',
  FACTORY_RELEASE_URL: apiBaseUrl + '/v1/ProductionBatches/generate',
  FACTORY_APPROVAL_URL: apiBaseUrl + '/v1/FactoryReleases',
  FACTORY_APPROVAL_PENDING_URL: apiBaseUrl + '/v1/FactoryReleases/approvals/pending',

    //Product Details
    PRODUCT_FAMILY_URL: apiBaseUrl + '/v1/Product/productfamily',
    PRODUCT_GROUPS_URL: apiBaseUrl + '/v1/Product/productgroups',
    PRODUCT_SUBGROUPS_URL: apiBaseUrl + '/v1/Product/productsubgroups',
    PRODUCT_SEARCH_URL: apiBaseUrl + '/v1/Product/productsearch',
    PRODUCT_VARIANTS_URL: apiBaseUrl + '/v1/Product/variants',
    PRODUCT_SPECIFICATION_URL: apiBaseUrl + '/v1/Product/specification',
    PRODUCTS_URL: apiBaseUrl + '/v1/Product/products',

    //Quotation Details    
    QUOTATION_URL: apiBaseUrl + '/v1/Quotation',
    QUOTATION_URL_STATUS: apiBaseUrl + '/v1/Quotation/quotestatus',
    QUOTATION_STATUS_UPDATE: apiBaseUrl + '/v1/Quotation/updatestatus',
    PRODUCT_MARK_URL: apiBaseUrl + '/v1/Quotation/mark',
    UPDATE_MARKNAME_URL: apiBaseUrl + '/v1/Quotation/renamemark',
    QUOTATION_SUMMARY_URL: apiBaseUrl + '/v1/Quotation/summary',
    QUOTATION_PROJECT_URL: apiBaseUrl + '/v1/Quotation/project',
    COPY_QUOTATION_URL: apiBaseUrl + '/v1/Quotation/copy',
    CONVERT_JIH_QUOTATION_URL: apiBaseUrl + '/v1/Quotation/convert',
    LOST_REASON_URL: apiBaseUrl + '/v1/Quotation/lostreasons',
    QUOTATION_REQUEST_URL: apiBaseUrl + '/v1/Quotation',
    QUOTATION_REQUEST_APPROVAL_URL: apiBaseUrl + '/v1/Quotation',
    QUOTATION_PENDING_URL: apiBaseUrl + '/v1/Quotation/approvals/pending',
    QUOTATION_APPROVAL_PENDING_URL: apiBaseUrl + '/v1/Quotation',
    MULTIPLE_MARGIN_URL: apiBaseUrl + '/v1/Quotation/marks/margins',

    //Configuration
    QUOTATION_ACTUATOR_LOCATIONS_URL: apiBaseUrl + '/v1/Configurations/life-safety-dampers/actuator-locations',
    QUOTATION_TRANSITION_TYPES_URL: apiBaseUrl + '/v1/Configurations/life-safety-dampers/transition-types',

    //List Price 
    LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/linear-slot-diffusers',
    CEILING_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/ceiling-diffusers',
    DEFLECTION_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/deflection-grilles',
    EXHAUSTGRILL_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/exhaust-grilles',
    TRANSFERGRILL_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/transfer-grilles',
    EGGCRATEGRILL_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/egg-crate-grilles',
    PORFORATED_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/perforated-diffusers',
    CIRCULAR_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/circular-diffusers',
    JET_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/jet-diffusers',
    NOZZLE_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/nozzle-diffusers',
    PUNKAH_NOZZLE_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/punkah-nozzle-diffusers',
    LINEAR_BAR_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/linear-bar-grilles',
    MITER_CORNER_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/miter-corner-linear-bar-grilles',
    FLOW_BAR_LIST_PRICE_URL: apiBaseUrl + '/v1/ListPrice/flow-bar-diffuser',
    MITER_CORNER_FBD_PRICE_URL: apiBaseUrl + '/v1/ListPrice/miter-corner-flow-bar-diffuser',
    MITER_CORNER_LSD_PRICE_URL: apiBaseUrl + '/v1/ListPrice/miter-corner-linear-slot-diffuser',
    CURVED_SLD_PRICE_URL: apiBaseUrl + '/v1/ListPrice/curved-linear-slot-diffuser',
    CURVED_FBD_PRICE_URL: apiBaseUrl + '/v1/ListPrice/curved-flow-bar-diffuser',
    CURVED_LB_GRILL_PRICE_URL: apiBaseUrl + '/v1/ListPrice/curved-linear-bar-grilles',
    DISC_VALVES_PRICE_URL: apiBaseUrl + "/v1/ListPrice/disc-valves",
    CURTAIN_FIRE_DAMPER_URL: apiBaseUrl + "/v1/ListPrice/curtain-fire-damper",
    DUCT_ACCESS_DOOR_DAMPER_URL: apiBaseUrl + "/v1/ListPrice/duct-access-door",
    ROUND_VOLUME_CONTROL_DAMPER_URL: apiBaseUrl + "/v1/ListPrice/round-volume-control-damper",
    COMBINATION_FIRE_SMOKE_URL: apiBaseUrl + "/v1/ListPrice/combination-fire-smoke-damper",
    FRESH_AIR_LOUVERS_PRICE_URL: apiBaseUrl + "/v1/ListPrice/fresh-air-louvers",
    SAND_TRAP_LOUVERS_PRICE_URL: apiBaseUrl + "/v1/ListPrice/sand-trap-louvers",

    // VAV Models
    PRESSURE_INDEPENDENT_VAV_PRICE_URL:
        apiBaseUrl + '/v1/ListPrice/variable-air-volumes/pressure-independent-vav',

    BYPASS_VAV_PRICE_URL:
        apiBaseUrl + '/v1/ListPrice/variable-air-volumes/bypass-vav',

    //Project Details
    PROJECT_LIST_URL: apiBaseUrl + '/v1/Project',
    PROJECT_SEGMENT_URL: apiBaseUrl + '/v1/Project/projectsegment',
    PROJECT_STATUS_URL: apiBaseUrl + '/v1/Project/projectstatus',

    //User Details
    USER_PROFILE_LIST: apiBaseUrl + '/v1/UserProfiles',
    USER_REGISTRATION_URL: apiBaseUrl + '/v1/Identity/registration',

    //Change password
    CHANGE_PASSWORD_URL: apiBaseUrl + '/v1/Identity/change-password',
    ADMIN_RESET_PASSWORD_URL: apiBaseUrl + '/v1/Identity/admin-reset-password',
    FORGOT_PASSWORD_URL: apiBaseUrl + '/v1/Identity/forgot-password',
    RESET_PASSWORD_URL: apiBaseUrl + '/v1/Identity/reset-password',

    //Customer Details
    CUSTOMER_POST_URL: apiBaseUrl + '/v1/Customer',
    CUSTOMERTYPE_LIST_URL: apiBaseUrl + '/v1/Customer/customertype',
    CUSTOMERTYPE_STATUS_URL: apiBaseUrl + '/v1/Customer/customerstatus',

    //Order Details
    ORDER_LIST_URL: apiBaseUrl + '/v1/Order',
    QUOTE_BALANCE_URL: apiBaseUrl + '/v1/Order/quote-balance',
    PENDING_QUOTATION: apiBaseUrl + '/v1/Order/pending-quotations',
    ORDER_PRODUCT_MARK_URL: apiBaseUrl + '/v1/Order/mark',

    //Forecast Details
    FORECAST_URL: apiBaseUrl + '/v1/Forecast',

    //Forecast Item
    FORECASTITEM_URL: apiBaseUrl + '/v1/ForecastItem/quotation',
    FORECASTITEM_QUOTE_PRODUCT_URl: apiBaseUrl + '/v1/ForecastItem/quote-product-item',
    FORECAST_PRODUCT_VIEW: apiBaseUrl + '/v1/ForecastItem/quote-product',

    //Multiplier Master
    MULTPLIER_URL: apiBaseUrl + '/v1/RoleMultiplier',

    //Approval Master
    APPROVAL_UPDATE_URL: apiBaseUrl + '/v1/Approval',

    //Notification
    NOTIFICATION_LATEST_URL: apiBaseUrl + '/v1/Notification/latest',
    NOTIFICATION_READ_URL: apiBaseUrl + '/v1/Notification',
    NOTIFICATION_READ_ALL_URL: apiBaseUrl + '/v1/Notification/read-all',
    NOTIFICATION_UNREAD_COUNT_URL: apiBaseUrl + '/v1/Notification/unread-count',

    //Customer Type Constants
    MEP_CUSTOMER: 2,
    MAIN_CUSTOMER: 1,
    DESIGN_CONSULTANT_CUSTOMER: 3,
    SUPER_VISION_CONSULTANT_CUSTOMER: 4,
    CLIENT_CUSTOMER: 5,

    //Static Status Retrieval from Backend
    SUCCESS_STATUS: 200,
    SUCCESS_STATUS_OPTION: 204,
    FAILURE_STATUS: 400,
    ERROR_STATUS: 500,

    //order constant
    VARIANT_STATIC_HEADING: [{ heading: "SDR Charges", fieldName: "sdrCharges" },
    { heading: "Quote Qty", fieldName: "quoteQuantity" },
    { heading: "Released Qty", fieldName: "releasedQuantity" },
    { heading: "LPO Qty", fieldName: "lpoQuantity" },
    { heading: "Multiplier", fieldName: "multiplier" }],
    HIDDEN_FIELDS_GROUP: [2, 4, 5, 8],

    //currency code
    CURRENCY_CODE: "QAR",

    NUMBER_VALIDATION_ARRAY: [5, 6, 8, 9, 46, 47, 19, 31, 22, 20, 21],
    VALIDATION_VARIANT_ARRAY: [5, 6, 7, 8, 9, 46, 47, 19, 31, 22, 20, 21],
    PRICE_CONSTANT: [12, 13, 14, 15, 50],
    LENGTH: [5],
    LENGTH_1: [46],
    LENGTH_2: [47],
    ANGLE: [19],
    NO_OF_SLOTS: [6],
    END_CAPS: [7],
    WIDTH: [9],
    HEIGHT: [31],
    QUANTITY_CONSTANT: [8],
    LIST_PRICE_CONSTANT: [12],
    NET_LIST_PRICE_CONSTANT: [13],
    UNIT_PRICE_CONSTANT: [14],
    NET_UNIT_PRICE_CONSTANT: [15],
    TAG_REF_CONSTANT: [3],
    OTHER_REF_CONSTANT: [4],
    FACE_LENGTH_ARRAY: [16],
    FACE_WIDTH_ARRAY: [17],
    FACE_HEIGHT_ARRAY: [40],
    FACE_DIAMETER: [45],
    SECTION_WIDTH_ARRAY: [41],
    SECTION_LENGTH_ARRAY: [10],
    SECTION_HEIGHT_ARRAY: [42],
    NO_OF_SECTION_ARRAY: [11],
    TRANSITION_ROUND_DIA: [35],
    TRANSITION_SQUARE_LENGTH_HEIGHT: [33, 34],
    TRANSITION_VARIANT_NONE: [33, 34, 35],
    PLENUM_NONE: [36, 37, 38],
    DIAMETER: [22],
    ARC_LENGTH: [20],
    ARC_RADIOUS: [21],
    SLEEVE_LENGTH: [24],

    //HeaderName id
    FACE_ID: [4],

    //Specification constant
    RAL_COLOUR: 4,
    BANK_OF_BLATE: 6,
    BANK_OF_BLATE_YES_VALUE: "Yes",
    BANK_OF_BLATE_NO_VALUE: "No",
    PLENUM: 8,
    PLENUM_NONE_VALUE: "None",
    PLENUM_WITH_INSULATION_VALUE: "With Internal Insulation",
    PLENUM_WITHOUT_INSULATION_VALUE: "Without Insulation",
    SHOW_ATTRIBUTES_ARRAY: [7, 10, 11, 12, 13, 14, 9, 59],
    PLENUM_ATTRIBUTES_WITH_ARRAY: [11, 12, 13, 14, 9, 59],
    PLENUM_ATTRIBUTES_WITHOUT_NOTALLOWEDARRAY: [11, 12, 13, 14, 59],
    PLENUM_ATTRIBUTES_WITHOUT_ALLOWEDARRAY: [9],
    BANK_OFF_BLATE_ARRAY: [7, 10],
    MATERIAL_OF_CONSTRUCTION: 3,

    TRANSITION: [58, 31],
    BOP_LENGTH: 51,
    BOP_LENGTHS: [51],
    BLANK_PLATE: 6,
    TRANSITION_NONE: "None",
    BLANK_PLATE_NONE: ["No", "None"],
    TRANSITION_ROUND: "Square to Round",
    TRANSITION_SQUARE: "Square to Square",
    CEILING_TYPE: 2,
    CEILING_MATERIAL: 3,
    SIZING: 24,
    INSTALLATION: 53,
    TYPE: 2,
    MOUNTING_PLATE_MATERIAL: 65,
    CONSTRUCTION_TYPE: 69,
    MITER_TYPE: 72,
    OPPOSED_BLADE_DAMPER: 5,
    SLEEVE_THICKNESS: 29,
    FIRE_RATING: 77,
    APPLICATION: 79,
    PRESSURE_RATING: 23,
    VELOCITY_RATING: 22,
    MATERIAL_THICKNESS: 89,
    INSULATION_MATERIAL: 87,
    INSULATION_THICKNESS: 88,
    FRAME_THICKNESS: 84,
    BLADE_THICKNESS: 85,
    BEARINGS: 86,
    HINGES: 91,
    HANDLE: 90,
    MATERIAL_CONSTRUCTION: 3,
    DEFLECTION_ANGLE: 107,
    CURVATURE_TYPE: 71,
    FRAME: 74,
    FRAME_TYPE: 103,
    SLOT_WIDTH: 1,
    HANGER_CLIP: 75,
    RAL_COLOR: 4,
    BUTTERFLY_DAMPER: 63,

    //Linear slot Diffuser constant
    //Product Variant Id
    SLOT_WIDTH: 1,
    WIDTH_HEIGHT_GROUP: [1, 9, 10, 12, 11, 7, 20, 21, 24, 16],
    LENGTH_HEIGHT_GROUP: [8],
    DIAMETER_GROUP: [5, 4, 6, 13, 23],
    LENGTH_NO_OF_SLOTS_GROUP: [2, 3],
    LENGTH1_LENGTH2_SLOTS_PRODUCT: [8, 5],
    CURVED_LENGTH_PRODUCT_ID: [4, 7],

    //Diff Users
    LINEAR_GROUP_ID: 2,
    MITTER_CORNER_LAD_PRODUCT_ID: 5,
    CURVED_LINEARSLOT_DIFF_USER_PRODUCT_ID: 4,

    CEILING_GROUP_ID: 1,
    NECK_APPEARANCE: 56,
    THROW_PATTERN: 57,
    TYPE_OF_COATING: 66,
    QUANTITY_VARIANT_ID: 8,
    NOMINAL_GROUP_ID: 3,
    PRICE_GROUP_ID: 5,

    PERFORATED_GROUP_ID: 7,
    CIRCULAR_DIFF_GROUP_ID: 5,
    JET_DIFF_GROUP_ID: 4,

    NO_OF_NOZZLES: 64,
    NOZZLE_GROUP_ID: 6,
    NOZZLE_PRODUCT_ID: 11,
    PUNKAH_NOZZLE_PRODUCT_ID: 12,

    FLOW_BAR_DIFF_GROUP_ID: 3,
    MITTER_CORNER_FLOW_BAR_PRODUCT_ID: 8,
    CURVED_FBD_PRODUCT_ID: 7,

    //Grilles
    DEFLECTION_GROUP_ID: 9,
    EXHAUST_GROUP_ID: 10,
    EGGCRATE_GROUP_ID: 12,
    TRANSFER_GROUP_ID: 11,
    DISC_VALVES_GROUP_ID: 13,

    LINEARBAR_GRILL_GROUP_ID: 8,
    LINEAR_BAR_PRODUCT_ID: 17,
    CURVED_LINEARBAR_GRILL_PRODUCT_ID: 20,
    MITER_CORNER_PRODUCT_ID: 18,

    //Life Safety Damper
    FIRE_DAMPER_GROUP_ID: 20,
    COMBINATION_FIRE_SMOKE_GROUP_ID: 21,
    SMOKE_DAMPER_GROUP_ID: 22,

    //Air control Damper
    DUCT_ACCESS_DOORS: 24,
    STEEL_CONTROL_DAMPER: 23,
    ROUND_VOLUME_CONTROL_PRODUCT_IDS: [259, 260, 261, 262],

    //Staging
    //BACK_OFFICE_ROLE_ID: ["a1ee5a94-b645-49cf-82ab-92cbb3dda175", "69257671-553b-49e7-9401-a95b70c97b01"],
    //ADMIN_ROLE_ID: "84218d3f-cbb4-420c-b3f1-e8cf8a44339e",

    //Production
    BACK_OFFICE_ROLE_ID: ["49eb4263-7641-4658-adee-adb4b4b8c6c4", "e7f616a9-67ae-4835-be50-6ef1a87aacc1", "299b171a-86c1-413a-8e3c-8d9d5144a6a6", "c8558fad-34f9-4f4c-b4fd-b34ae4038f5d"],
    ADMIN_ROLE_ID: "30a9d08f-f03b-457b-93ee-7b8551e96528",

    //Deflection Grills
    BLADE_SPACING: 60,
    BLADE_ORIENTATION: 61,

    // CFD
    CFD_FIRE_RATING: 77,
    CFD_CLOSURE: 78,
    CFD_TYPE: 2,
    CFD_VELOCITY: 22,
    CFD_FUSIBLE_LINK_RATING: 80,
    CFD_ACCESSORIES: 82,
    CFD_DUCT: 43,
    CFD_MOUNT: 83,
    CFD_TRANSITION_TYPE: 31,

    //CFSD 
    ACTUATOR_MODEL_CONSTANT: [48],
    ACTUATOR_QTY_CONSTANT: [49],
    ACTUATOR_COST_CONSTANT: [50],
    CFSD_BASE_MODEL: 17,
    CFSD_LEAKAGE_CLASS: 18,
    CFSD_MOUNTING_ORIENTATION: 19,
    CFSD_TEMPERATURE_CLASS: 20,
    CFSD_BEARING_MATERIAL: 25,
    CFSD_AXLE_MATERIAL: 26,
    CFSD_JACKSHAFT: 27,
    CFSD_SLEEVE_TYPE: 28,
    CFSD_SLEEVE_LENGTH_ATTR: 30,
    CFSD_TRANSITION_TYPE: [52],
    CFSD_ACTUATOR_TYPE: 32,
    CFSD_ACTUATOR_VOLTAGE: 33,
    CFSD_ACTUATOR_OPERATION: 34,
    CFSD_INTEGRAL_AUX_SWITCH: 35,
    CFSD_ACTUATOR_LOCATION: 36,
    ACTUATOR_LOCATION: [26],
    CFSD_CLOSURE_DEVICE: 37,
    CFSD_CLOSURE_TEMPERATURE: 38,
    CFSD_SMOKE_DETECTOR: 46,
    CFSD_MOUNTING_ACCESSORIES: 42,
    CFSD_DUCT_CONNECTION: 43,
    CFSD_SECURITY_BARS: 44,
    CFSD_PNEUMATIC_ACCESSORIES: 45,

    CFSD_ACTUATOR_MAKE: 100,
    CFSD_ACTUATOR_MOUNT: 0,
    CFSD_JAMB_SEAL: 0,
    CFSD_BLADE_SEAL: 0,
    CFSD_TRANSITION_DETAILS: 0,
    CFSD_REMOTE_TESTBOX: 0,
    CFSD_SWITCH_TYPE: 0,
    CFSD_FRAME_TYPE: 0,

    //Fresh Air Louvers
    FRESH_AIR_LOUVERS_GROUP_ID: 16,
    FRESH_AIR_LOUVERS_PRODUCT_ID: 405,
    FRESH_AIR_SCREEN: 95,
    FRESH_AIR_FILT_THICK: 96,
    FRESH_AIR_OUTER_FLANGE: 97,

    //Sand Trap Louvers
    SAND_TRAP_LOUVERS_GROUP_ID: 16,
    SAND_TRAP_LOUVERS_PRODUCT_ID: 39,

    //VAV (Variable Air Volume)
    VAV_GROUP_ID: 26,
    PRESSURE_VAV_GROUP_ID: 27,
    VAV_MODEL: [54],
    VAV_INLET_DIA: [32],
    VAV_AIR_VOLUME: [53],
    VAV_ORIENTATION: [55],
    VAV_CASING_THICKNESS: 92,
    VAV_INLET_TYPE: 93,
    VAV_CASING_TYPE: 0,
    VAV_INNER_WALL_TYPE: 0,

    VAV_INSULATION_THICKNESS: 111,
    VAV_INSULATION_LINEAR: 110,
    VAV_CASING_TYPE: 108,

    PRESSURE_INDEPENDENT_VAV_PRODUCT_ID: 0,
    BYPASS_VAV_PRODUCT_ID: 0,
};


export default urls;